import { BROADCAST_SET_PROGRAM } from 'actions/Types';

/**
 * This action is used on the preview page to set the preview program.
 * We use this to reduce the complexity of the main setProgram.
 * This doesn't require any api call and other actions being taken in the main setProgram action.
 * @param scene object the scene to set the program to
 */
export default scene => {
  return (dispatch, _, socket) => {
    socket.disconnect();
    const action = {
      type: BROADCAST_SET_PROGRAM,
      payload: scene,
      isTransient: true
    };

    dispatch(action);
  };
};
